import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import ConvertHeight from '../components/ConvertHeight'

export default class ModContentSlider {
  constructor(el) {
    this.$el = $(el)

    this.mySwiper = null

    this.attributes = {
      style: 'style',
    }

    this.dom = {
      $swiper: this.$el.find('.swiper'),
      $swiperButtonNext: this.$el.find('.swiper-button-next'),
      $swiperButtonPrevious: this.$el.find('.swiper-button-prev'),
      $heightItem: this.$el.find('.convert-height'),
      $swiperWrapper: this.$el.find('.swiper-wrapper'),
      $swiperSlide: this.$el.find('.swiper-slide'),
      $containerSwiper: this.$el.find('.container-swiper'),
      $scrollLine: this.$el.find('.scroll-line'),
      $panelScroll: this.$el.find('.panel-scroll'),
      $lineFakeScroll: this.$el.find('.line-fake-scroll'),
    }
    this.scrollbarScaleFactor = 1
    this.lastLoggedIndex = -1
    this.converter = new ConvertHeight(this.dom.$heightItem)
  }

  init() {
    this.updateScrollBarFactorResize()
    this.addSwiper()
    this.callConvertHeight()
    this.setWidth()
    let timeout = null
    $(window).on('resize orientationchange', () => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        this.updateScrollBarFactorResize()
        this.callConvertHeight()
        this.setWidth()
      }, 100)
    })

    this.dom.$panelScroll.on('scroll', () => {
      this.dom.$lineFakeScroll.css('transition', 'none')
      this.onPanelScroll()
      this.updateColorScrollBarWhenScroll()
    })
  }

  updateColorScrollBarWhenScroll() {
    const swiperSlides = this.mySwiper.slides
    const lineFakeScrollLeft = this.dom.$lineFakeScroll.offset().left
    const lineFakeScrollRight = lineFakeScrollLeft + this.dom.$lineFakeScroll.width()

    let maxOverlap = 0
    let closestSlideIndex = 0

    swiperSlides.forEach((slide, index) => {
      const $slide = $(slide)
      const offsetLeft = $slide.offset().left
      const offsetRight = offsetLeft + $slide.outerWidth()

      const overlapLeft = Math.max(lineFakeScrollLeft, offsetLeft)
      const overlapRight = Math.min(lineFakeScrollRight, offsetRight)
      const overlapWidth = Math.max(0, overlapRight - overlapLeft)

      if (overlapWidth > maxOverlap) {
        maxOverlap = overlapWidth
        closestSlideIndex = index
      }
    })

    if (closestSlideIndex !== this.lastLoggedIndex) {
      this.lastLoggedIndex = closestSlideIndex
      const $itemActive = this.dom.$swiperSlide.eq(closestSlideIndex)
      this.updateScrollbarColor($itemActive)
    }
  }

  updateScrollBarFactorResize() {
    if (window.innerWidth > 1199) {
      this.scrollbarScaleFactor = 3
    } else if (window.innerWidth > 767) {
      this.scrollbarScaleFactor = 1.25
    } else {
      this.scrollbarScaleFactor = 1
    }
  }

  callConvertHeight() {
    this.converter.convertHeight()
  }

  addSwiper() {
    this.mySwiper = new Swiper(this.dom.$swiper[0], {
      modules: [Navigation],
      speed: 500,
      slidesPerView: 1,
      navigation: {
        nextEl: this.dom.$swiperButtonNext[0],
        prevEl: this.dom.$swiperButtonPrevious[0],
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1200: {
          slidesPerView: 3,
        },
      },
      on: {
        init: (swiper) => {
          const $itemActive = $(swiper.slides[swiper.activeIndex])
          this.updateScrollbarColor($itemActive)
        },
        slideChangeTransitionEnd: () => {
          this.dom.$lineFakeScroll.css('transition', 'left 0.3s ease-in-out, background-color 0.1s')
          this.updateFakeScrollPosition()
          setTimeout(() => {
            this.updateColorScrollBarWhenScroll()
          }, 301)
        },
      },
    })
  }

  isDesktopBigger1439() {
    return $(window).outerWidth() > 1439
  }

  setWidth() {
    const containerSwiperWidth = this.dom.$containerSwiper.width()
    let widthContent = this.dom.$swiperSlide.innerWidth() * this.dom.$swiperSlide.length * this.scrollbarScaleFactor

    this.dom.$scrollLine.css('width', `${widthContent}px`)
    if (this.isDesktopBigger1439()) {
      this.dom.$scrollLine.removeAttr(this.attributes.style)
      widthContent = this.dom.$scrollLine.innerWidth()
    }

    this.dom.$lineFakeScroll.css('width', `${(containerSwiperWidth / widthContent) * containerSwiperWidth}px`)
  }

  updateFakeScrollPosition() {
    const containerSwiperWidth = this.dom.$containerSwiper.width()
    const widthContentOriginal = this.dom.$swiperSlide.innerWidth() * this.dom.$swiperSlide.length
    let widthContent = this.dom.$swiperSlide.innerWidth() * this.dom.$swiperSlide.length * this.scrollbarScaleFactor
    if (this.isDesktopBigger1439()) {
      this.dom.$scrollLine.removeAttr(this.attributes.style)
      widthContent = this.dom.$scrollLine.innerWidth()
    }
    const transformMatrix = this.dom.$swiperWrapper.css('transform')
    const matrixValues = transformMatrix.match(/matrix.*\((.+)\)/)[1].split(', ')
    const scrollLeft =
      (matrixValues[4] / (widthContent - containerSwiperWidth)) *
      (containerSwiperWidth - (containerSwiperWidth / widthContent) * containerSwiperWidth)
    this.dom.$lineFakeScroll.css(
      'left',
      Math.abs(
        scrollLeft / ((widthContentOriginal - containerSwiperWidth - 16) / (widthContent - containerSwiperWidth)),
      ),
    )
  }

  onPanelScroll() {
    const containerSwiperWidth = this.dom.$containerSwiper.width()
    const widthContentOriginal = this.dom.$swiperSlide.innerWidth() * this.dom.$swiperSlide.length
    let widthContent = this.dom.$swiperSlide.innerWidth() * this.dom.$swiperSlide.length * this.scrollbarScaleFactor
    if (this.isDesktopBigger1439()) {
      this.dom.$scrollLine.removeAttr(this.attributes.style)
      widthContent = this.dom.$scrollLine.innerWidth()
    }
    const scrollLeftPanelScroll = this.dom.$panelScroll.scrollLeft()
    const scrollLeft =
      (scrollLeftPanelScroll / (widthContent - containerSwiperWidth)) *
      (containerSwiperWidth - (containerSwiperWidth / widthContent) * containerSwiperWidth)
    this.dom.$lineFakeScroll.css('left', `${scrollLeft}px`)
    const transformSwiperWrapper =
      scrollLeftPanelScroll *
      ((widthContentOriginal - containerSwiperWidth - 16) / (widthContent - containerSwiperWidth))

    this.dom.$swiperWrapper.css('transform', `translate3d(${-transformSwiperWrapper}px, 0px, 0px)`)
  }

  updateScrollbarColor($itemActive) {
    const $lineItemActive = $itemActive.find('.line-color')
    const styleAttribute = $lineItemActive.attr(this.attributes.style)
    let hexBackgroundColor = '#ebad57'
    if (styleAttribute) {
      const match = styleAttribute.match(/background-color:\s*([^;]*)/)
      hexBackgroundColor = match ? match[1] : null
    }
    this.dom.$lineFakeScroll.css('background-color', hexBackgroundColor)
  }
}

const $modContentSlider = $('.mod-content-slider')
if ($modContentSlider.length) {
  $modContentSlider.each((_, element) => {
    new ModContentSlider(element).init()
  })
}